import {Component} from '@angular/core';
import {NgbActiveOffcanvas} from "@ng-bootstrap/ng-bootstrap/offcanvas";
import {SidebarService} from "./sidebar.service";
import {Section, SectionService} from "../../services/section.service";
import {faAt} from "@fortawesome/free-solid-svg-icons/faAt";
import {faMapLocationDot} from "@fortawesome/free-solid-svg-icons/faMapLocationDot";
import {faPhone} from "@fortawesome/free-solid-svg-icons/faPhone";
import {faFacebookSquare} from "@fortawesome/free-brands-svg-icons/faFacebookSquare";
import {faInstagram} from "@fortawesome/free-brands-svg-icons/faInstagram";
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {Constants} from "../../constants";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [FaIconComponent]
})
export class SidebarComponent {

  protected withServices = false;
  protected withBlog = false;

  protected readonly faPhone = faPhone;
  protected readonly faAt = faAt;
  protected readonly faMapLocationDot = faMapLocationDot;
  protected readonly faInstagram = faInstagram;
  protected readonly faFacebookSquare = faFacebookSquare;

  protected readonly routes = Constants.Routes;
  protected readonly contact = Constants.Contact;
  protected readonly address = Constants.Address;
  protected readonly social = Constants.Social;
  protected readonly sections: Array<Section>;

  constructor(private readonly activeOffCanvas: NgbActiveOffcanvas,
              private readonly sidebarService: SidebarService,
              readonly sectionService: SectionService) {
    this.sidebarService.updateRef(this.activeOffCanvas);
    this.sections = sectionService.getSections();
  }

  servicesVisible(visible: boolean) {
    this.withServices = visible;
    return this;
  }

  blogVisible(visible: boolean) {
    this.withBlog = visible;
    return this;
  }

  dismiss(section: Section | null) {
    this.activeOffCanvas.dismiss();
    if (section != null) {
      setTimeout(() => window.location.href = '#' + section.id, 50);
    }
  }
}
